<template>
    <div :style="barStyle">
        <span :class="type">
            {{ percentage }}%
        </span>
    </div>
</template>

<script>
/**
 * A simple rendering component for a Bar to show percentage
 */
export default {
    name: 'analysis-bar',
    props: {
        /**
		 * The absolute value of responses for the Bar 
		 */
        value: {
            type: Number,
            required: true
        },
        /**
         * The total value of responses
         */
        total: {
            type: Number,
            required: true
        },
        /**
         * The color of the Bar
         */
        color: {
            type: String,
            default: '#ccccccc'
        },
        /**
         * The type of Bar 
         * @values `vertical`, `horizontal`
         */
        type: {
            type: String,
            default: 'horizontal',
            validator: (value) => ['horizontal', 'vertical'].includes(value)
        }
    },
    computed: {
        percentage() {
            return Math.round(this.value / this.total * 100)
        },
        barStyle() {
            return {
                width: (this.type === 'vertical') ? (this.percentage + '%') : '100%',
                height: (this.type === 'vertical') ?  '100%' : (this.percentage + '%'),
                background: this.color
            }
        }
    }
}
</script>

<style scoped>
.horizontal{
    font-size: 10px;
    position: absolute;
    bottom: 2px;
    left: 1px;
}
.vertical{
    padding-left: 5px;
}
</style>
